import React from 'react';

import {
    TimerIcon, EcoFriendlyIcon, SendIcon, BadgeIcon
} from '../primitive/icons/pdpIcons';

import homePageV2Messages from './assets/messages/homePageMessages';
import { getFormattedMessage } from '../utils/textUtils';


export const digitalHighlightBulletLists = (intl) => {
    

    const bulletText = [
        {
            icon: <TimerIcon />,
            text: getFormattedMessage(intl, homePageV2Messages.digitalDescriptionBullet1)
        },
        {
            icon: <EcoFriendlyIcon />,
            text: getFormattedMessage(intl, homePageV2Messages.digitalDescriptionBullet2)
        },
        {
            icon: <SendIcon />,
            text: getFormattedMessage(intl, homePageV2Messages.digitalDescriptionBullet3)
        },
        {
            icon: <BadgeIcon />,
            text: getFormattedMessage(intl, homePageV2Messages.digitalDescriptionBullet4)
        }
    ];

    
    const sortedDigitalHighlightBulletLists = bulletText.filter(item => item.text.trim() !== '');

    return sortedDigitalHighlightBulletLists;
};
